// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, recordOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsAppIdSdkAuthenticationAnalyticsResult = objectOf({
  errors: recordOf({ key: string, value: arrayOf(arrayOf(number)) }),
});
